<template>
  <div class="tw-bg-white tw-shadow-lg tw-rounded-lg tw-pointer-events-auto tw-z-50">
    <div class="tw-rounded-lg tw-shadow-xs tw-overflow-hidden">
      <div class="tw-p-4">
        <div class="tw-flex tw-items-start">
          <div class="tw-flex-shrink-0">
            <alert-icon class="tw-h-6 tw-w-6 tw-text-red-600 tw-bg-red-200 tw-p-1 tw-rounded-full" v-if="isError" />
            <check-icon class="tw-h-6 tw-w-6 tw-text-green-600 tw-bg-green-200 tw-p-1 tw-rounded-full" v-else />
          </div>
          <div class="tw-ml-3 tw-w-0 tw-flex-1 tw-pt-0.5">
            <p class="tw-leading-5 tw-text-gray-900 tw-font-thin tw-mb-0">{{ title }}</p>
            <p class="tw-mt-1 tw-text-sm tw-leading-5 tw-text-gray-500 tw-font-light tw-mb-0">{{ message }}</p>
          </div>
          <div class="tw-ml-4 tw-flex-shrink-0 tw-flex">
            <button @click="$emit('remove')" class="tw-inline-flex tw-text-gray-400 focus::tw-outline-none focus::tw-text-gray-500 tw-transition tw-ease-in-out tw-duration-150">
              <x-icon class="tw-h-5 tw-w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XIcon, CheckIcon, AlertIcon } from "@/assets/svgs";

export default {
  components: {
    XIcon,
    CheckIcon,
    AlertIcon,
  },
  props: {
    id: Number,
    title: {
      type: String,
      required: true,
    },
    message: String,
    isError: Boolean,
  },
};
</script>
